module.exports = __webpack_public_path__ + "static/media/image-4.39deec53.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Neighborhood/image-4.png
// module id = 265
// module chunks = 0